export default __webpack_public_path__ + "aa6cce4e80e6bfef20fd66d5e26fb760.png";